import React from 'react'
import { Icon as ChakraIcon } from '@chakra-ui/react'
import {
  HubResponsiveValue,
  StandardIconSizes,
  HubStyleObject,
  forwardRef,
} from '@hub/design-system-base'
import { default as DirectLogoSVG } from './assets/direct-digital-logo.inline.svg'

interface DirectLogoProps {
  boxSize?: HubResponsiveValue<StandardIconSizes>
  sx?: HubStyleObject
  mono?: boolean
  label?: string
}

export const DirectLogo: React.FC<DirectLogoProps> = forwardRef<
  DirectLogoProps,
  typeof ChakraIcon
>(
  (
    {
      boxSize = 'size-icon-line-height-shorter',
      sx,
      mono = false,
      label = 'Westfield Direct',
    },
    ref
  ) => {
    const color = mono ? 'licorice' : 'vibrantTeal'

    return (
      <ChakraIcon
        aria-label={label}
        ref={ref}
        minW={boxSize}
        maxH={boxSize}
        w="size-auto"
        h="size-auto"
        as={DirectLogoSVG}
        sx={{
          '& .chevron': {
            color,
          },
          ...sx,
        }}
      />
    )
  }
)
